// extracted by mini-css-extract-plugin
export default {"container":"ModuleLessons_container__r1QZv","lessons":"ModuleLessons_lessons__q-2JJ"};